import { Features, hasFeature } from '@ardoq/features';
import { dispatchAction } from '@ardoq/rxbeach';
import type {
  GraphInputMode,
  IModelItem,
  ItemClickedEventArgs,
} from '@ardoq/yfiles';
import { openDetailsDrawer } from 'appLayout/ardoqStudio/detailsDrawer/actions';
import { componentSelectedInQuickExploreMode } from 'traverseOneLevel/actions';
import { isDiscoverJourney } from 'canvas/isDiscoverJourney';
import { componentSelectedInPresentationMode } from 'streams/components/ComponentActions';
import { isPresentationMode } from 'env';

const graphViewpointModeItemDoubleClickedListener = (
  e: ItemClickedEventArgs<IModelItem>,
  _: GraphInputMode
) => {
  if (!e.item.tag || !e.item.tag.isComponent?.()) return;
  e.handled = true;
  const modelId = e.item.tag.modelId;

  if (isPresentationMode()) {
    dispatchAction(componentSelectedInPresentationMode({ id: modelId }));
    return;
  }

  if (isDiscoverJourney() || hasFeature(Features.CANVAS_PROTOTYPE)) {
    dispatchAction(componentSelectedInQuickExploreMode(modelId));
  } else {
    dispatchAction(openDetailsDrawer([modelId]));
  }
};

export { graphViewpointModeItemDoubleClickedListener };
